import { jsx } from "react/jsx-runtime";
import cx from "classnames";
const Skeleton = (props) => {
  const {
    /* Prefix all classes in every element with this string */
    prefix = "",
    /* Can be used to add classes to base HTML element. */
    className,
    /* Set skeleton width with inline style */
    width = "100%",
    /* Set skeleton height with inline style */
    height,
    inlineBlock,
    tagName = "div",
    ...other
  } = props;
  const classes = cx(
    `${prefix}skeleton`,
    inlineBlock && `${prefix}skeleton--inline-block`,
    className
  );
  const TagName = tagName;
  return /* @__PURE__ */ jsx(TagName, { style: { width, height }, className: classes, ...other });
};
var Skeleton_default = Skeleton;
export {
  Skeleton_default as default
};
